import React from "react";
import "./SimpleSteps.css";
import vectorOne from "../../../../../../Assets/Images/pl-details-vector.webp";
import vectorTwo from "../../../../../../Assets/Images/icon-two.webp";
import vectoThree from "../../../../../../Assets/Images/icon-three.webp";
import vectorFour from "../../../../../../Assets/Images/icon-four.webp";

const SimpleSteps = () => {
  return (
    <>
      <div id="">
        <div id="four-simple-steps-container">
          <div id="steps-content-page">
            <div className="heading-text-container">
              <h4 className="heading-text px-2">
                Get started in 4 simple steps
              </h4>
            </div>
            <div className="steps-page-content d-flex flex-row flex-md-column">
              <div id="vectors-img-container">
                <div className="image-content-section d-flex flex-column flex-md-row gap-4 justify-content-center align-items-center align-items-md-start justify-content-md-between  pt-md-3 ">
                  {/* image one */}

                  <div className=" vector-img-text-container loan_against_vector_img d-flex flex-column gap-3 gap-lg-3 ">
                    <div className="vector-image-one ">
                      <img
                        id="img-one"
                        className="bg-transparent"
                        src={vectorOne}
                        alt="vector-img"
                      />
                    </div>
                    <div
                      id="vector-text-one"
                      className="loan_aganinst_property"
                    >
                      <p className="describe text-center">
                        Submit your property & financial details
                      </p>
                    </div>
                  </div>

                  {/* image two */}

                  <div className=" vector-img-text-container loan_against_vector_img d-flex flex-column  gap-3 gap-lg-3 ">
                    <div className="vector-image-two image-two-box">
                      <img
                        id="img-two"
                        className="bg-transparent"
                        src={vectorTwo}
                        alt="vector-img"
                      />
                    </div>
                    <div
                      id="vector-text-two"
                      className="loan_aganinst_property"
                    >
                      <p className="describe text-center">
                        Get a pre-approval call from our lending partner
                      </p>
                    </div>
                  </div>

                  {/* image three */}

                  <div className=" vector-img-text-container loan_against_vector_img d-flex flex-column   gap-3 gap-lg-3 ">
                    <div className="vector-image-three">
                      <img
                        id="img-three"
                        className="bg-transparent"
                        src={vectoThree}
                        alt="vector-img"
                      />
                    </div>
                    <div
                      id="vector-text-three"
                      className="loan_aganinst_property"
                    >
                      <p className="describe text-center">
                        Property valuation & legal check
                      </p>
                    </div>
                  </div>

                  {/* image four */}

                  <div className=" vector-img-text-container loan_against_vector_img d-flex flex-column flex-md-column  gap-3 gap-lg-3 ">
                    <div className="vector-image-four">
                      <img
                        id="img-four"
                        className="bg-transparent"
                        src={vectorFour}
                        alt="vector-img"
                      />
                    </div>
                    <div
                      id="vector-text-four"
                      className="loan_aganinst_property"
                    >
                      <p className="describe text-center">
                        Loan Disbursement upon approval
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleSteps;
